import { View } from 'react-native';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { styles } from './TotalProductsSummaryTooltipContent.styles';
import { useStore } from 'src/contexts/StoreContext';
import { getFormattedPrice } from 'src/helpers/price.helper';
import { observer } from 'mobx-react-lite';

export const TotalProductsSummaryTooltipContent = observer(() => {
  const { project, i18n } = useStore();
  const { totalItems, groups } = project.activeProject?.priceDetails ?? { totalItems: 0, groups: [] };
  return totalItems > 0 ? (
    <View style={styles.tooltip}>
      <View style={styles.content}>
        <TextLato
          style={styles.tooltipTitle}
        >{`${i18n.t('header:total')} (${totalItems} ${i18n.t('header:product', { count: totalItems })})`}</TextLato>
        <View style={styles.entries}>
          {groups.map(elem => {
            return (
              <View style={styles.entry} key={i18n.t(elem.titleKey)}>
                <TextLato style={styles.entryTitle}>{i18n.t(elem.titleKey)}</TextLato>
                {elem.items.map(item => {
                  const titleKey = i18n.t(item.titleKey);
                  return (
                    <View style={styles.entryElem} key={item.format}>
                      <View style={styles.entryVoice}>
                        <View style={styles.bullet} />
                        <TextLato style={styles.entryText}>
                          {i18n.t('discounts-tooltip:n-units-size', {
                            quantity: item.quantity,
                            format: titleKey,
                          })}
                        </TextLato>
                      </View>
                      <View style={styles.entryInfo}>
                        {item.discountPercentage > 0 && (
                          <>
                            <TextLato style={styles.entryDiscount}>{`-${item.discount}`}</TextLato>
                            <TextLato style={styles.entryOriginal}>
                              {getFormattedPrice({ price: item.originalTotalPrice, withCurrency: true })}
                            </TextLato>
                          </>
                        )}
                        <TextLato style={styles.entryEstimate}>
                          {getFormattedPrice({
                            price: item.discountPercentage > 0 ? item.discountedTotalPrice : item.originalTotalPrice,
                            withCurrency: true,
                          })}
                        </TextLato>
                      </View>
                    </View>
                  );
                })}
              </View>
            );
          })}
        </View>
      </View>
    </View>
  ) : (
    <> </>
  );
});
